import type { Hooks } from '#packages/apilib';
import type { CompRef } from 'types/documentServices';
import type { HistoryAddOptions } from '@/history';

export interface LayoutMoveByOptions extends HistoryAddOptions {}
export interface LayoutMoveToOptions extends HistoryAddOptions {}

export type LayoutMoveByParams =
  | {
      deltaX: number;
      deltaY?: number;
    }
  | {
      deltaX?: number;
      deltaY: number;
    }
  | {
      deltaX: number;
      deltaY: number;
    };

export type LayoutMoveByInterceptor = Hooks.InterceptorHookInterceptor<{
  compRefs: CompRef[];
  params: LayoutMoveByParams;
}>;

export interface LayoutMoveHooks {
  moveByInterceptor: Hooks.InterceptorHook<{
    compRefs: CompRef[];
    params: LayoutMoveByParams;
  }>;
}
